<div class="edit-job-tags-wrapper">
    <h4 class="job-detail-title">{{ 'TCW_Tags' | translate }}</h4>
    <div class="filter-field">
        <!-- panelWidth is set to 0 to make the width auto -->
        <chip-filter
            id="edit-tags"
            [placeholder]="placeholder"
            [selectable]="true"
            [multiInputMode]="true"
            [editable]="true"
            [class]="'tag-input-alternative'"
            [selectedChips]="jobTags"
            [allChips]="allTags"
            [panelWidth]="0"
            [caseSensitive]="false"
            (addChipEvent)="addTag($event)"
            (removeChipEvent)="removeTag($event)"
        ></chip-filter>
    </div>
</div>
